var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"支社・事業所管理","icon":"fas fa-users-cog"}},[_c('base-error-guard',[_c('group-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }